exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.options-list[data-v-6ab94634] {\n        min-width: 150px;\n        max-width: 500px;\n        max-height: 1000%;\n        overflow: scroll;\n}\n", ""]);

// exports
